function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapFooterBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 837.1066,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 877.5798,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 918.053,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 958.5262,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 998.9994,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1039.4726,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1079.9458,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1120.419,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.8922,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.3654,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1241.8385,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.3117,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1322.7849,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1363.2581,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.1066,
    cy: 179.4832,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 877.5798,
    cy: 179.4832,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 918.053,
    cy: 179.4832,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 958.5262,
    cy: 179.4832,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 998.9994,
    cy: 179.4832,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1039.4726,
    cy: 179.4832,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1079.9458,
    cy: 179.4832,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1120.419,
    cy: 179.4832,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.8922,
    cy: 179.4832,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.3654,
    cy: 179.4832,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1241.8385,
    cy: 179.4832,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.3117,
    cy: 179.4832,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1322.7849,
    cy: 179.4832,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1363.2581,
    cy: 179.4832,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 918.053,
    cy: 219.9564,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 958.5262,
    cy: 219.9564,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 998.9994,
    cy: 219.9564,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1039.4726,
    cy: 219.9564,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1079.9458,
    cy: 219.9564,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1120.419,
    cy: 219.9564,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.8922,
    cy: 219.9564,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.3654,
    cy: 219.9564,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1241.8385,
    cy: 219.9564,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.3117,
    cy: 219.9564,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1322.7849,
    cy: 219.9564,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 918.053,
    cy: 260.4296,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 958.5262,
    cy: 260.4296,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 958.5262,
    cy: 300.9028,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 998.9994,
    cy: 260.4296,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1039.4726,
    cy: 260.4296,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1079.9458,
    cy: 260.4296,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1120.419,
    cy: 260.4296,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.8922,
    cy: 260.4296,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.3654,
    cy: 260.4296,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1241.8385,
    cy: 260.4296,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.3117,
    cy: 260.4296,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1322.7849,
    cy: 260.4296,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1079.9458,
    cy: 300.9028,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1120.419,
    cy: 300.9028,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.8922,
    cy: 300.9028,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.3654,
    cy: 300.9028,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1241.8385,
    cy: 300.9028,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.3117,
    cy: 300.9028,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1322.7849,
    cy: 300.9028,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1120.419,
    cy: 341.376,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.8922,
    cy: 341.376,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.3654,
    cy: 341.376,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1241.8385,
    cy: 341.376,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.3117,
    cy: 341.376,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1322.7849,
    cy: 341.376,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1403.7313,
    cy: 341.376,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1444.2045,
    cy: 341.376,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1484.6777,
    cy: 341.376,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.8922,
    cy: 380.8373,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.3654,
    cy: 380.8373,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1241.8385,
    cy: 380.8373,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.3117,
    cy: 380.8373,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1322.7849,
    cy: 380.8373,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1363.2581,
    cy: 380.8373,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1403.7313,
    cy: 380.8373,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1444.2045,
    cy: 380.8373,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1484.6777,
    cy: 380.8373,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.8922,
    cy: 420.2987,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1120.419,
    cy: 420.2987,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.3654,
    cy: 420.2987,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1241.8385,
    cy: 420.2987,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.3117,
    cy: 420.2987,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1322.7849,
    cy: 420.2987,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1363.2581,
    cy: 420.2987,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1403.7313,
    cy: 420.2987,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.8922,
    cy: 460.7719,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.3654,
    cy: 460.7719,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1241.8385,
    cy: 460.7719,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.3117,
    cy: 460.7719,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1322.7849,
    cy: 460.7719,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1363.2581,
    cy: 460.7719,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1403.7313,
    cy: 460.7719,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.3654,
    cy: 501.2451,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1241.8385,
    cy: 501.2451,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.3117,
    cy: 501.2451,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.3654,
    cy: 541.7182,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1241.8385,
    cy: 541.7182,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.3117,
    cy: 541.7182,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1322.7849,
    cy: 501.2451,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1363.2581,
    cy: 501.2451,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.3117,
    cy: 582.1914,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1322.7849,
    cy: 582.1914,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1302.5483,
    cy: 622.6646,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1343.0215,
    cy: 622.6646,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1363.2581,
    cy: 582.1914,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1403.7313,
    cy: 501.2451,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1388.5539,
    cy: 663.1378,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1429.027,
    cy: 663.1378,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1469.5002,
    cy: 663.1378,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1509.9734,
    cy: 663.1378,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1388.5539,
    cy: 703.611,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1429.027,
    cy: 703.611,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1469.5002,
    cy: 703.611,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1509.9734,
    cy: 703.611,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1550.4466,
    cy: 703.611,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1590.9198,
    cy: 703.611,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1388.5539,
    cy: 744.0842,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1429.027,
    cy: 744.0842,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1469.5002,
    cy: 744.0842,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1509.9734,
    cy: 744.0842,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1550.4466,
    cy: 744.0842,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1590.9198,
    cy: 744.0842,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1631.393,
    cy: 744.0842,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1429.027,
    cy: 783.5456,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1469.5002,
    cy: 783.5456,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1509.9734,
    cy: 783.5456,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1550.4466,
    cy: 783.5456,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1590.9198,
    cy: 783.5456,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1429.027,
    cy: 824.0188,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1469.5002,
    cy: 824.0188,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1509.9734,
    cy: 824.0188,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1550.4466,
    cy: 824.0188,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1429.027,
    cy: 864.4919,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1469.5002,
    cy: 864.4919,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1509.9734,
    cy: 864.4919,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1550.4466,
    cy: 864.4919,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1429.027,
    cy: 904.9651,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1469.5002,
    cy: 904.9651,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1509.9734,
    cy: 904.9651,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1429.027,
    cy: 945.4383,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1469.5002,
    cy: 945.4383,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1429.027,
    cy: 985.9115,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1469.5002,
    cy: 985.9115,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1429.027,
    cy: 1026.3847,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1429.027,
    cy: 1066.8579,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1469.5002,
    cy: 1026.3847,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1509.9734,
    cy: 945.4383,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1550.4466,
    cy: 904.9651,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1590.9198,
    cy: 824.0188,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1631.393,
    cy: 783.5456,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1403.7313,
    cy: 541.7182,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1429.027,
    cy: 622.6646,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1444.2045,
    cy: 420.2987,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1363.2581,
    cy: 219.9564,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1403.7313,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1444.2045,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1423.9679,
    cy: 179.4832,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1464.4411,
    cy: 179.4832,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1423.9679,
    cy: 219.9564,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1464.4411,
    cy: 219.9564,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1423.9679,
    cy: 259.4177,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1464.4411,
    cy: 259.4177,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1423.9679,
    cy: 299.8909,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1464.4411,
    cy: 299.8909,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.8922,
    cy: 98.5368,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.3654,
    cy: 98.5368,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1241.8385,
    cy: 98.5368,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.3117,
    cy: 98.5368,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1322.7849,
    cy: 98.5368,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1363.2581,
    cy: 98.5368,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1403.7313,
    cy: 98.5368,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1160.8922,
    cy: 58.0636,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1201.3654,
    cy: 58.0636,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1241.8385,
    cy: 58.0636,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1282.3117,
    cy: 58.0636,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1322.7849,
    cy: 58.0636,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1542.352,
    cy: 58.0636,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1582.8252,
    cy: 58.0636,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1623.2984,
    cy: 58.0636,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1663.7716,
    cy: 58.0636,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1704.2447,
    cy: 58.0636,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1542.352,
    cy: 17.5904,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1582.8252,
    cy: 17.5904,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1623.2984,
    cy: 17.5904,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1663.7716,
    cy: 17.5904,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1704.2447,
    cy: 17.5904,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1894.4687,
    cy: 178.4714,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1894.4687,
    cy: 218.9445,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1894.4687,
    cy: 259.4177,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1853.9956,
    cy: 259.4177,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1894.4687,
    cy: 298.8791,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1853.9956,
    cy: 298.8791,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1813.5224,
    cy: 298.8791,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1894.4687,
    cy: 340.3641,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1853.9956,
    cy: 340.3641,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1813.5224,
    cy: 340.3641,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1773.0492,
    cy: 340.3641,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1894.4687,
    cy: 542.7301,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1853.9956,
    cy: 542.7301,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1813.5224,
    cy: 542.7301,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1773.0492,
    cy: 542.7301,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1732.576,
    cy: 542.7301,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1894.4687,
    cy: 583.2033,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1853.9956,
    cy: 583.2033,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1813.5224,
    cy: 583.2033,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1773.0492,
    cy: 583.2033,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1732.576,
    cy: 583.2033,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1894.4687,
    cy: 623.6765,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1853.9956,
    cy: 623.6765,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1813.5224,
    cy: 623.6765,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1773.0492,
    cy: 623.6765,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1732.576,
    cy: 623.6765,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1894.4687,
    cy: 664.1496,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1853.9956,
    cy: 664.1496,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1813.5224,
    cy: 664.1496,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1773.0492,
    cy: 664.1496,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1894.4687,
    cy: 784.5574,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1894.4687,
    cy: 825.0306,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1894.4687,
    cy: 703.611,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1894.4687,
    cy: 744.0842,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1894.4687,
    cy: 502.2569,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1853.9956,
    cy: 502.2569,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1813.5224,
    cy: 502.2569,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1773.0492,
    cy: 502.2569,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1894.4687,
    cy: 421.3105,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1853.9956,
    cy: 421.3105,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1813.5224,
    cy: 421.3105,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1773.0492,
    cy: 421.3105,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1813.5224,
    cy: 461.7837,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1773.0492,
    cy: 461.7837,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1894.4687,
    cy: 380.8373,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1853.9956,
    cy: 380.8373,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1813.5224,
    cy: 380.8373,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1542.352,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1582.8252,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1623.2984,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1542.352,
    cy: 178.4714,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1582.8252,
    cy: 178.4714,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1542.352,
    cy: 218.9445,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1582.8252,
    cy: 218.9445,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1582.8252,
    cy: 259.4177,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1623.2984,
    cy: 178.4714,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1663.7716,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1704.2447,
    cy: 139.01,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1704.2447,
    cy: 178.4714,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1744.7179,
    cy: 178.4714,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1704.2447,
    cy: 218.9445,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1744.7179,
    cy: 218.9445,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1542.352,
    cy: 98.5368,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1582.8252,
    cy: 98.5368,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1623.2984,
    cy: 98.5368,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1663.7716,
    cy: 98.5368,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1704.2447,
    cy: 98.5368,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1363.2581,
    cy: 58.0636,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1403.7313,
    cy: 58.0636,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1444.2045,
    cy: 98.5368,
    r: 12.6479,
    style: {
      fill: "#004f32"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapFooterBg);
export default __webpack_public_path__ + "static/media/map-footer-bg.2b692a38ed6fb917c286e1c4c274b480.svg";
export { ForwardRef as ReactComponent };